import { PhoneticType } from '../constants';
import getPhoneticSystem from '../systems/getPhoneticSystem';

const convertSystem = (text: string, system: string): string => {
    const target = getPhoneticSystem(system);
    const source = target.name === PhoneticType.Yale ? PhoneticType.Jyutping : PhoneticType.Yale;
    return target.convertTo(text, source);
};

export default convertSystem;
